import { toast } from 'vue-sonner';
import WorkflowSheet from '@/components/sheets/WorkflowSheet.vue';
import useApi from '@/composables/useApi.ts';
import useSheet from '@/composables/useSheet.ts';
import type { Workflow } from '@/types/api';

export default function useWorkflow() {
    const useFetch = useApi();
    const sheet = useSheet();

    async function start(handle: string, title: string) {
        const { data, error } = await useFetch<Workflow>('workflow/' + handle);

        if (error.value || !data.value) {
            toast.error('Der Assistent konnte nicht gestartet werden.');
            console.error(error.value);
            return;
        }

        await sheet.start({
            title: title,
            class: 'w-full md:w-3/4 lg:w-1/2 xl:w-164',
            component: WorkflowSheet,
            props: {
                workflow: data.value,
            },
        });
    }

    return {
        start,
    };
}
